import axios from 'axios'

export default {
  data () {
    return {
      lastWatchSeconds: null,
      pausedWatchTimer: null
    }
  },
  methods: {
    smartTrackVideoWatch (video, player, trackParams, shouldSendBeforeUnload = false) {
      if (!player) {
        return
      }

      const watchSeconds = player.currentTime()
      const duration = player.duration()

      if (watchSeconds < 3) {
        return
      }

      if (watchSeconds > this.lastWatchSeconds) {
        const req = {
          type: this.constants.App_Models_Track.ACTION_WATCH,
          ...trackParams,
          data: {
            duration: watchSeconds,
            percent: Math.min(duration === 0 ? 1 : watchSeconds / duration, 1)
          }
        }
        this.lastWatchSeconds = watchSeconds

        if (shouldSendBeforeUnload) {
          const blob = new Blob(
            [JSON.stringify(req)],
            {
              type: 'application/json'
            }
          )

          navigator.sendBeacon(this.router('api.video.track', { video: video.id, type: req.type, from_beancon: 1 }), blob)
          return
        }

        axios.post(this.router('api.video.track', { video: video.id, type: req.type }), req, {
          ignoreGlobalCatch: true
        })
      }
    },
    trackPausedVideoWatch (player, trackCb) {
      if (player.duration() > 0) {
        this.cancelPausedVideoWatch()

        this.pausedWatchTimer = setTimeout(
          trackCb,
          player.duration() * 1000 * 2
        )
      }
    },
    cancelPausedVideoWatch () {
      if (this.pausedWatchTimer) {
        clearTimeout(this.pausedWatchTimer)
        this.pausedWatchTimer = null
      }
    }
  }
}
